import moment from 'moment';
import React, {useRef} from 'react';
import {CopyInput} from '../../../system/CopyInput/CopyInput';
import css from './CouponsCheckoutThankYou.module.css';

export const CouponsCheckoutThankYou = () => {
  const searchParams = useRef(
    new URLSearchParams(window?.location?.search)
  ).current;
  const coupon = searchParams.get('coupon');
  const duration = searchParams.get('duration');
  const durationInDays = duration ? moment.duration(duration).asDays() : 0;

  return (
    <div className={css.root}>
      <h1 className={css.title}>Amazing, your coupon is here!</h1>
      <div className={css.topDescription}>
        <div className={css.topDescriptionText}>
          <p>
            One last step left: just copy the code below and send it however you
            like. You will also receive this coupon on the email address you
            used for the purchase, but we recommend you save it already!
          </p>
          <p>
            How to redeem?
            <br />
            Coupons can be redeemed in the dashboard{' '}
            <a
              className={css.link}
              href={`https://pulsoid.net/ui/dashboard?action=redeem-coupon&coupon=${coupon}`}
              target="_blank"
            >
              here
            </a>
            .
          </p>
        </div>
        <img
          className={css.topDescriptionMascot}
          src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Fpurchase-thank-top.png"
        />
      </div>

      <div className={css.couponContainer}>
        <img
          src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Fpurchase-thank-bottom.png"
          alt="redeem coupon mascot"
          className={css.couponMascot}
        />

        {coupon ? (
          <div className={css.coupon}>
            <h5 className={css.couponCodeTitle}>Coupon code:</h5>
            <CopyInput value={coupon} className={css.couponCopy} />
            <div className={css.couponCodeDescription}>
              gives {durationInDays} days of the BRO plan, valid for 1 use
              <br />
              valid for a year from the day of purchase
            </div>
          </div>
        ) : null}

        <div className={css.fakeMascot} />
      </div>

      <div className={css.footerContainer}>
        <div>
          <h4 className={css.footerTitle}>How to redeem</h4>
          <div className={css.footerSubtitle}>
            Just follow these 3 small steps:
          </div>
        </div>

        <div className={css.footerPuchaseSteps}>
          <div className={css.puchaseStep}>
            <div className={css.purchaseStepTitle}>
              <span className={css.puchaseStepNumber}>1. </span>
              Click '
              <a
                href={`https://pulsoid.net/ui/dashboard?action=redeem-coupon&coupon=${coupon}`}
                target="_blank"
                className={css.link}
              >
                Redeem Coupon
              </a>
              ' in the Dashboard
            </div>
            <img
              src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Fpurchase-redeem-steps-1.png"
              alt="visit dashboard maskot"
              className={css.puchaseStepMascot}
            />
          </div>

          <div className={css.puchaseStep}>
            <div className={css.purchaseStepTitle}>
              <span className={css.puchaseStepNumber}>2. </span>
              Validate your coupon & click 'Redeem'
            </div>
            <img
              src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Fpurchase-redeem-steps-2.png"
              alt="validate coupon maskot"
              className={css.puchaseStepMascot}
            />
          </div>

          <div className={css.puchaseStep}>
            <div className={css.purchaseStepTitle}>
              <span className={css.puchaseStepNumber}>3. </span>
              Start using Pulsoid to its full potential
            </div>
            <img
              src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Fpurchase-redeem-steps-3.png"
              alt="start using pulsoid maskot"
              className={css.puchaseStepMascot}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
